module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app_container",
    style: (_vm.conStyle)
  }, [_c('div', {
    staticClass: "login_title",
    style: (_vm.logoText_style)
  }), _vm._v(" "), (_vm.ifLogin) ? _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("用户登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "用户名/手机号"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "remember",
    on: {
      "click": _vm.forgetPwdFn
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('span', {
    staticClass: "registBtn"
  }, [_vm._v("没有账号？"), _c('span', {
    staticClass: "registText",
    on: {
      "click": _vm.registBtnFn
    }
  }, [_vm._v("立即注册")])])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2.apply(null, arguments)
      }
    }
  }, [_vm._v("登  录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.ruleForm2.userAgree),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "userAgree", $$v)
      },
      expression: "ruleForm2.userAgree"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "6px"
    }
  }, [_vm._v("\n          登录即同意撤除平台"), _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "#2850a7",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.handleUserAgreement
    }
  }, [_vm._v("隐私政策")])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.ifLogin) ? _c('el-form', {
    ref: "registParamsData",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.registParamsData,
      "rules": _vm.registRules,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("用户注册")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "PhoneNum"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.registParamsData.PhoneNum),
      callback: function($$v) {
        _vm.$set(_vm.registParamsData, "PhoneNum", $$v)
      },
      expression: "registParamsData.PhoneNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "Password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.registParamsData.Password),
      callback: function($$v) {
        _vm.$set(_vm.registParamsData, "Password", $$v)
      },
      expression: "registParamsData.Password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "height": "0px",
      "line-height": "0px",
      "margin": "0px"
    },
    attrs: {
      "prop": "PhoneNum"
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "PasswordAgin"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "确认密码"
    },
    model: {
      value: (_vm.registParamsData.PasswordAgin),
      callback: function($$v) {
        _vm.$set(_vm.registParamsData, "PasswordAgin", $$v)
      },
      expression: "registParamsData.PasswordAgin"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "VCode"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "验证码"
    },
    model: {
      value: (_vm.registParamsData.VCode),
      callback: function($$v) {
        _vm.$set(_vm.registParamsData, "VCode", $$v)
      },
      expression: "registParamsData.VCode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "forget-getcode",
    class: _vm.ifClick ? 'noclick' : '',
    on: {
      "click": _vm.getCaptcha
    }
  }, [_vm._v("\n        " + _vm._s(_vm.entityText) + "\n      ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "loginBtn"
  }, [_vm._v("已有账号？"), _c('span', {
    staticClass: "loginText",
    on: {
      "click": _vm.loginBtnFn
    }
  }, [_vm._v("登录")])]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.regLoading
    },
    on: {
      "click": function($event) {
        return _vm.handleReginst('registParamsData')
      }
    }
  }, [_vm._v("注  册")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a136cd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 1198
// module chunks = 1